/*
 * @Author: changcheng
 * @LastEditTime: 2022-09-16 17:59:54
 */
export const centerClassification = [
  {
    id: 0,
    name: "肿瘤防治中心",
  },
  {
    id: 1,
    name: "慢病管理中心",
  },
  {
    id: 2,
    name: "微创介入中心",
  },
  {
    id: 3,
    name: "麻醉疼痛诊疗中心",
  },
  {
    id: 4,
    name: "重症监护中心",
  },
  {
    id: 5,
    name: "胸痛中心",
  },
  {
    id: 6,
    name: "卒中中心",
  },
  {
    id: 7,
    name: "创伤中心",
  },
  {
    id: 8,
    name: "危重孕产妇救治中心",
  },
  {
    id: 9,
    name: "危重儿童和新生儿救治中心",
  },
  {
    id: 10,
    name: "医学检验中心",
  },
  {
    id: 11,
    name: "医学影像中心",
  },
  {
    id: 12,
    name: "心电诊断中心",
  },
  {
    id: 13,
    name: "病理中心",
  },
  {
    id: 14,
    name: "消毒供应中心",
  },
  {
    id: 15,
    name: "医疗质控中心",
  },
  {
    id: 16,
    name: "人力资源中心",
  },
  {
    id: 17,
    name: "运营管理中心",
  },
  {
    id: 18,
    name: "医保管理中心",
  },
  {
    id: 19,
    name: "信息数据中心",
  },
  {
    id: 20,
    name: "其他",
  },
];
